import React, { useMemo } from 'react';
import DispositionToolListRow from './DispositionToolListRow';
import './DispositionToolList.css';

export default function DispositionToolList({
  tools,
  selectedToolId,
  onSelect,
  gapsOnly,
  loading,
  error,
}) {
  // Server sort is canonical. Only apply the gaps-only client filter --
  // never re-sort.
  const visible = useMemo(() => {
    if (!Array.isArray(tools)) return [];
    if (!gapsOnly) return tools;
    return tools.filter(t => t.gap_level !== 'complete');
  }, [tools, gapsOnly]);

  if (loading) {
    return <div className="dispositions-list-state">Loading...</div>;
  }
  if (error) {
    return <div className="dispositions-list-state error">{error}</div>;
  }
  if (!visible.length) {
    return (
      <div className="dispositions-list-state">
        {gapsOnly ? 'No tools with data gaps.' : 'No tools.'}
      </div>
    );
  }

  return (
    <div className="dispositions-list">
      {visible.map(t => (
        <DispositionToolListRow
          key={t.tool_id}
          tool={t}
          selected={t.tool_id === selectedToolId}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
